module.exports = __webpack_public_path__ + "static/media/john.a61870a7.png";